import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';
import { MedicalNoteType, MedicalNoteResponse } from './medicalNotes';
import { Diagnosis, TreatPatientMedication, TreatPatientMedicationSelfReported } from '@uplift/types';

export type DischargeNoteResponse = MedicalNoteResponse<MedicalNoteType.therapyDischargeNote | MedicalNoteType.psychiatryDischargeNote>;

export const createDischargeNote = async (patientId: string) =>
  restClient.request<DischargeNoteResponse>(`/api/v1/patient/${patientId}/medical_notes/discharge_note`, {
    method: 'POST',
    data: snakecaseKeys({ dischargeNoteForm: {} })
  });

export type UpdateDischargeNoteInput = {
  diagnosisIds?: string[];
  dischargeNoteForm?: Record<string, unknown>;
  isSubmitted?: boolean;
};

export const updateDischargeNote = async (noteId: string, data: UpdateDischargeNoteInput) =>
  restClient.request<DischargeNoteResponse>(`/api/v1/medical_notes/discharge_note/${noteId}`, {
    method: 'PATCH',
    data: snakecaseKeys(data)
  });

export const deleteDischargeNote = async (noteId: string) =>
  restClient.request<DischargeNoteResponse>(`/api/v1/medical_notes/discharge_note/${noteId}`, {
    method: 'DELETE'
  });


export const getCreateDischargeNoteButtonStatus = async (patientId: string) => restClient.request<{ data: boolean }>(`/api/v1/patient/${patientId}/medical_notes/discharge_note/button_status`);


export type TherapyDischargeNoteCourseOfTreatment = {
  treatmentStartDate: string;
  treatmentEndDate: string;
  submittedSessionsCount: number;
  initialAssessmentSubmissionIds: string[];
  initialDiagnosis: Diagnosis[];

  treatmentAndInterventionsNotes: string[];
};

export type PsychiatryDischargeNoteCourseOfTreatment = {
  treatmentStartDate: string;
  treatmentEndDate: string;
  submittedSessionsCount: number;

  chiefComplaint: string;
  psychiatricReviewOfSystemsNote: string;
  psychAssessments: {
    name: string;
    result: string;
  }[];
  initialAssessmentSubmissionIds: string[];
  initialDiagnosis: Diagnosis[];

  medicationHistory: TreatPatientMedication[];
  dischargeMedication: TreatPatientMedicationSelfReported[];
};
